import { Theme } from '@fagmobler/sanity';
import clsx from 'clsx';
import { Button } from '../buttons';

type CampaignBannerProps = {
  title?: string;
  cta?: string;
  theme?: Theme;
  children?: React.ReactNode;
};

export const CampaignBanner = ({
  theme = 'neutral',
  title,
  cta,
  children,
}: CampaignBannerProps) => {
  return (
    <div
      className={clsx(
        'flex flex-col items-center justify-center relative p-16 text-center',
        {
          'bg-neutral-40 text-neutral-80': theme === 'neutral',
          'text-neutral-0 bg-neutral-80': theme === 'neutralDark',
          'bg-brown-30 text-neutral-80': theme === 'lightBrown',
          'bg-tetiery-30 text-neutral-80': theme === 'lightYellow',
          'bg-green-40 text-neutral-80': theme === 'lightGreen',
          'bg-tetiery-60 text-neutral-80': theme === 'blackWeekYellow',
          'bg-neutral-80 text-tetiery-50': theme === 'blackWeekBlack',
          'bg-brown-70 text-gold-40': theme === 'nobel',
          'bg-primary-50 text-neutral-0': theme === 'red',
          'bg-brown-70 text-pink-60': theme === 'garden',
        }
      )}
    >
      <h2 className="hd-6xl font-bold pb-2 break-words">{title}</h2>
      <p className="pb-10 body-lg max-w-lg">{children}</p>
      <Button
        size="lg"
        className={clsx('p-4 border-none', {
          // black button
          '!bg-neutral-80 !text-neutral-0':
            theme !== 'blackWeekBlack' &&
            theme !== 'nobel' &&
            theme !== 'garden',
          // white button
          '!bg-neutral-0 !text-neutral-80':
            theme === 'blackWeekBlack' ||
            theme === 'nobel' ||
            theme === 'garden',
        })}
      >
        {cta}
      </Button>
    </div>
  );
};
